import React, { useEffect, useState } from 'react';
import { ReferrerResponse } from "../typings";
import { Row } from "../components/Flex";
import { useParams } from "react-router-dom";
import { useApi } from "../api-context";
import { fetchReferrer } from "./referral-api";

function ReferralPage() {
    const api = useApi();
    const [referrer, setReferrer] = useState<ReferrerResponse>();

    const { id } = useParams();

    const loadReferrer = () => {
        if (!id) {
            return;
        }
        fetchReferrer(api, Number(id))
            .then(setReferrer)
            .catch(console.error);
    };

    useEffect(() => {
        loadReferrer();
    }, []);

    return (
        <>
            <div className="group-page-header">
                <Row gap={8}>
                    <div style={{ flex: 1 }}>
                        {referrer?.email}
                    </div>
                </Row>
            </div>
            <div className="page-container">
                <div className="content-container" style={{ marginBottom: '32px' }}>
                    <div style={{ display: 'flex', gap: '16px', width: '100%' }}>
                        <div className="box" style={{ flex: 1, gap: '12px' }}>
                            <div className="ingo-title">Referrals</div>
                            {referrer?.referrals?.map(refferal => (
                                <div className="label">{refferal.email} - Completed {refferal.confirmed ? 'YES' : 'NO'}</div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ReferralPage;
